const phoneSaleDataModule = [
    {
        path: "/PSDataModule",
        name: "电销数据模块",
        component: () =>
            import(
                "../views/telemarketingTicketSystem/dataModule/index.vue"
            ),
        meta: { id: 597, hidden: false, name: "dataModulelxy.dataModule" },
        children: [
            {
                path: "/PSDashboard",
                name: "电销数据看板",
                component: () =>
                    import(
                        "../views/telemarketingTicketSystem/dataModule/dashboard.vue"
                    ),
                meta: { id: 598, hidden: false, name: "performance.dashboard" }
            },
            {
                path: "/PSPerformanceList",
                name: "电销绩效列表",
                component: () =>
                    import(
                        "../views/telemarketingTicketSystem/dataModule/PerformanceList.vue"
                    ),
                meta: { id: 599, hidden: false, name: "dataModulelxy.dataList" }
            }
        ]
    },
];
export default phoneSaleDataModule;